import PageShell from '@/pages/shared/PageShell';
import { usePricing } from '../../hooks/usePricing';
import Button from '@/components/base/Button';
import { Link } from 'react-router-dom';

export default function Pricing() {
  // 💰⚙️の料金設定と自動連動
  const pr = usePricing();
  const fmt = (n: number) => n.toLocaleString('ja-JP');
  return (
    <PageShell
      title="料金｜AIプロジェクト管理ツール ”おもいむすび”"
      description="”おもいむすび”の料金プラン。基本料40,000円/月（1社）、プロジェクト利用料5,000円/月、ユーザー利用料500円/月。すべて税別。無料お試しあり（プロジェクト1件・3名まで／期限なし）。"
      keywords="プロジェクト管理ツール 料金,AI プロジェクト管理 料金,プロジェクト管理 SaaS 料金,タスク管理 料金"
      canonical="https://omoimusubi.asia/pricing/"
      h1="会社の規模に合わせた、分かりやすい料金"
      subtitle="必要な分だけ使える従量制。すべて税別価格です。"
      relatedLinks={[
        { label: '無料トライアル', path: '/free-trial/' },
        { label: '機能一覧', path: '/features/' },
        { label: 'プロジェクト管理ツール比較', path: '/compare/project-management-tools/' },
      ]}
    >
      <div className="not-prose mb-10 rounded-xl overflow-hidden border border-background-200/70">
        <img
          src="https://readdy.ai/api/search-image?query=A%20bright%20modern%20Japanese%20office%20scene%20with%20a%20Japanese%20business%20team%20three%20people%20in%20their%2030s%20sitting%20around%20a%20wooden%20meeting%20table%20reviewing%20pricing%20documents%20on%20a%20laptop%20screen%20the%20laptop%20displays%20a%20clean%20pricing%20plan%20comparison%20page%20with%20three%20tiers%20natural%20daylight%20through%20large%20windows%20indoor%20plants%20minimalist%20Japanese%20contemporary%20office%20interior%20refreshing%20positive%20atmosphere%20professional%20yet%20approachable&width=1200&height=600&seq=pricing-hero-01&orientation=landscape"
          alt="料金プランのイメージ - チームで料金プランを検討するビジネスシーン"
          className="w-full h-auto"
        />
      </div>
      <div className="not-prose grid grid-cols-1 md:grid-cols-3 gap-6 my-10">
        {[
          { label: '基本料', price: pr.base, unit: '月額 / 1社', desc: '”おもいむすび”の全機能をご利用いただけます。' },
          { label: 'プロジェクト利用料', price: pr.project, unit: '月額 / 1プロジェクト', desc: '管理するプロジェクト数に応じて追加。' },
          { label: 'ユーザー利用料', price: pr.user, unit: '月額 / 1ユーザー', desc: '利用するメンバー数に応じて追加。' },
        ].map((item) => (
          <div key={item.label} className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
            <p className="text-xs text-foreground-500 mb-2">{item.label}</p>
            <p className="text-4xl font-bold text-foreground-950 mb-1">&yen;{item.price}</p>
            <p className="text-xs text-foreground-500 mb-3">{item.unit}</p>
            <p className="text-xs text-foreground-600">{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="not-prose bg-primary-50 rounded-lg p-6 border border-primary-200/70 my-8">
        <h3 className="text-base font-bold text-foreground-900 mb-4">料金例：プロジェクト3件、ユーザー10名の場合</h3>
        <div className="space-y-2 text-sm text-foreground-600">
          <div className="flex justify-between"><span>基本料</span><span>&yen;{pr.base}</span></div>
          <div className="flex justify-between"><span>プロジェクト利用料（3件 × &yen;{pr.project}）</span><span>&yen;{fmt(3 * pr.projectN)}</span></div>
          <div className="flex justify-between"><span>ユーザー利用料（10名 × &yen;{pr.user}）</span><span>&yen;{fmt(10 * pr.userN)}</span></div>
          <div className="flex justify-between font-bold text-foreground-900 pt-2 border-t border-primary-200"><span>月額合計（税別）</span><span>&yen;{fmt(pr.baseN + 3 * pr.projectN + 10 * pr.userN)}</span></div>
        </div>
      </div>

      <section>
        <h2>無料お試し</h2>
        <p>正式な導入前に、無料でお試しいただけます（プロジェクト1件・メンバー3名まで／期限なし）。主要機能を実際のプロジェクトで確認し、自社のプロジェクト管理に適しているかをご判断ください。</p>
        <p>「完全無料」「永久無料」ではありません。全機能・制限なしの正式利用を開始すると月額料金が発生します。</p>
      </section>

      <section>
        <h2>よくある質問</h2>
        <h3>最低利用期間はありますか</h3>
        <p>最低利用期間の設定はございません。月単位でのご契約となります。</p>
        <h3>プロジェクト数やユーザー数は途中で変更できますか</h3>
        <p>はい。プロジェクト数やユーザー数は、月中でも追加・削減が可能です。ご利用状況に応じて柔軟に変更いただけます。</p>
      </section>

    </PageShell>
  );
}